import React from 'react';
import { createStackNavigator } from '../navigation/stack';
import { useDispatch } from 'react-redux';
import { LogBox } from '../web/react-native';

import Report from '../../components/Report';
import LogDetails from '../../components/LogDetails';
import TakeOverSubmit from '../../components/TakeOver/takeOverSubmit';
import MyPost from '../../components/MyPosts/MyPost';
import useAppState from '../hooks/useAppState';
import { Route } from './Route';

import {
  PreferencesScreen,
  CreateShiftLogScreen,
  EditingScreen,
  PostCommentScreen,
  UpdatePercentageScreen,
  EditingGroupScreen,
  EditingRollupScreen,
  EditingRowListScreen,
  EditingRowScreen,
  ActionListScreen,
  ActionScreen,
} from '../screens';
import {
  selectCurrentSiteCode,
  preferenceActions,
} from '../store';
import { AppDispatch } from '../store/store';
import { StandingOrderAction, TaskAction, UUID } from '../services/dataModels';
// import { ActionListScreen } from '../screens/actionList';

/**
 * Ignoring this warning as LogDetails.js is passing non-serializable props through the navigation routes
 */
LogBox.ignoreLogs(['Non-serializable values were found in the navigation state']);

const RootStack = createStackNavigator();

const Navigation = () => {
  const dispatch = useDispatch<AppDispatch>();

  const siteCode = selectCurrentSiteCode.useHook();

  useAppState({
    didBecomeActive: () => {
      refreshPreferences();
    },
  });

  const refreshPreferences = () => {
    if (siteCode) dispatch(preferenceActions.getPreferencesForSite(siteCode));
  };

  return (
    <RootStack.Navigator
      screenOptions={{
        headerShown: false, //Set to true when switching over to the refactored implementatation of the ReportsScreen
      }}>
      <RootStack.Screen name={Route.preferenceNavScreen} component={PreferencesScreen} />
      {/* <RootStack.Screen
        name={Route.logReportsScreen}
        component={LogReportsScreen}
      /> */}
      <RootStack.Screen name={Route.reportScreen} component={Report} />
      <RootStack.Screen name={Route.logDetailsScreen} component={LogDetails} />
      <RootStack.Screen name={Route.takeOverSubmitScreen} component={TakeOverSubmit} />
      <RootStack.Screen name={Route.myPost} component={MyPost} />
      <RootStack.Screen name={Route.createShiftLogScreen} component={CreateShiftLogScreen} />
      <RootStack.Screen name={Route.editShiftLogScreen} component={EditingScreen} />
      <RootStack.Screen name={Route.actionListScreen} component={ActionListScreen} />
      <RootStack.Screen name={Route.actionScreen} component={ActionScreen} />
      <RootStack.Screen name={Route.postComment} component={PostCommentScreen} />
      <RootStack.Screen name={Route.updatePercentage} component={UpdatePercentageScreen} />

      <RootStack.Screen name={Route.editingGroupScreen} component={EditingGroupScreen} />
      <RootStack.Screen name={Route.editingRollupScreen} component={EditingRollupScreen} />
      <RootStack.Screen name={Route.editingRowListScreen} component={EditingRowListScreen} />
      <RootStack.Screen name={Route.editingRowScreen} component={EditingRowScreen} />
    </RootStack.Navigator>
  );
};

interface EditShiftLogScreenProps {
  isTeamLog: boolean;
}
interface CreateShiftLogScreenProps {
  isTeamLog: boolean;
}

export interface EditingSnippetProps extends EditShiftLogScreenProps {
  snippetId: UUID;
  lastLink?: string;
}

export interface EditingGroupScreenProps extends EditingSnippetProps {
  groupIndex?: number[];
}

export type EditingRollupScreenProps = EditingGroupScreenProps;

export interface EditingRowListScreenProps extends EditingRollupScreenProps {
  rollupIndex?: number;
}

export interface EditingRowScreenProps extends EditingRowListScreenProps {
  rowIndex: number;
}

export type PostCommentScreenProps = EditingRowScreenProps;

export type UpdatePercentageScreenProps = EditingRowScreenProps;

export interface EditingRowActionProps extends EditingRowScreenProps {
  action: TaskAction | StandingOrderAction;
}

export type RootStackParamList = {
  EditShiftLogScreen: EditShiftLogScreenProps;
  CreateShiftLogScreen: CreateShiftLogScreenProps;

  PostCommentScreen: PostCommentScreenProps;
  UpdatePercentageScreen: UpdatePercentageScreenProps;

  EditingGroupScreen: EditingGroupScreenProps;
  EditingRollupScreen: EditingRollupScreenProps;
  EditingRowListScreen: EditingRowListScreenProps;
  EditingRowScreen: EditingRowScreenProps;

  EditingRowAction: EditingRowActionProps;
};

export default Navigation;
